import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmissionsChartComponent } from 'src/app/shared/charts/emissions-chart/emissions-chart.component';
import { UIComponentsModule } from 'src/app/shared/ui-components/ui-components.module';
import { GroupsService } from '../groups.service';
import { SnackbarService } from 'src/app/core/services/snackbar/snackbar.service';

@Component({
  selector: 'app-user-report',
  imports: [UIComponentsModule, EmissionsChartComponent],
  templateUrl: './user-report.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-report.component.scss'
})
export class UserReportComponent implements OnInit {
  // Data for the emissions report
  reportData: any = null;

  groupId: number | null = null;
  userId: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private groupsService: GroupsService,
    private snackbarService: SnackbarService
  ) {}

  ngOnInit(): void {
    this.route.params
      .subscribe(params => {
        this.groupId = +params['groupId'];
        this.userId = +params['userId'];
        
        if (this.groupId && this.userId) {
          this.loadUserEmissionsReport();
        } else {
          this.snackbarService.showErrorMessage('Invalid group or user ID');
        }
      });
  }

  private loadUserEmissionsReport(): void {
    if (this.groupId === null || this.userId === null) {
      this.snackbarService.showErrorMessage('Group or User ID is missing');
      return;
    }
    this.groupsService.getUserEmissionsReport(this.groupId, this.userId)
      .subscribe({
        next: (data) => {
          this.reportData = data;
        },
        error: (error) => {
          if (error.status === 404) {
            this.snackbarService.showErrorMessage('Emission Data for the provided User not found');
          }
          else if (error.status === 403) {
            this.snackbarService.showErrorMessage('You do not have permission to view this report.');
          } else {
            this.snackbarService.showErrorMessage('An unexpected error occurred while loading the report');
          }
        }
      });
  }
}
